import React from 'react'
import { Dropdown, Row, Col } from 'react-bootstrap'

export type ResponseLimitingStrategy = 'no_limiting' | 'legacy' | 'panopticon'

const ResponseLimitingDropdown = ({
  value,
  onChange,
  isDisabled = false,
}: {
  value: ResponseLimitingStrategy
  onChange: (strategy: ResponseLimitingStrategy) => void
  isDisabled?: boolean
}) => {
  const getDisplayText = (strategy: ResponseLimitingStrategy) => {
    switch (strategy) {
      case 'no_limiting':
        return 'No Response Limiting'
      case 'legacy':
        return 'Legacy'
      case 'panopticon':
        return 'Panopticon'
      default:
        return 'Unknown'
    }
  }

  const getVariant = (strategy: ResponseLimitingStrategy) => {
    switch (strategy) {
      case 'no_limiting':
        return 'danger'
      case 'legacy':
        return 'warning'
      case 'panopticon':
        return 'primary'
      default:
        return 'secondary'
    }
  }

  return (
    <Row>
      <Col
        md="auto"
        className="d-flex align-items-center"
        style={{ paddingRight: '0px' }}
      >
        <strong>Response Limiting Strategy: </strong>
      </Col>
      <Col style={{ paddingLeft: '0px' }}>
        <Dropdown className="my-2">
          <Dropdown.Toggle
            variant={getVariant(value)}
            className={`p-1 ${isDisabled ? ' disabled' : ' '}`}
            disabled={isDisabled}
          >
            {getDisplayText(value)}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => onChange('no_limiting')}>
              <div>
                <strong>No Response Limiting</strong>
                <div className="text-muted small">
                  User can send unlimited messages
                </div>
              </div>
            </Dropdown.Item>
            <Dropdown.Item onClick={() => onChange('legacy')}>
              <div>
                <strong>Legacy</strong>
                <div className="text-muted small">
                  Use existing response limiting decisions
                </div>
              </div>
            </Dropdown.Item>
            <Dropdown.Item onClick={() => onChange('panopticon')}>
              <div>
                <strong>Panopticon</strong>
                <div className="text-muted small">
                  Use panopticon for response limiting decisions
                </div>
              </div>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Col>
    </Row>
  )
}

export default ResponseLimitingDropdown
